<template>
  <el-dialog
    title="历史操作"
    :visible.sync="visible"
    width="70%"
    @open="open"
    @close="$emit('input', '')"
  >
    <el-table :data="data" v-loading="loading">
      <el-table-column property="hisotry_name" label="操作人"></el-table-column>
      <el-table-column property="history_time" label="操作时间"></el-table-column>
      <el-table-column property="history_atime" label="选择时间"></el-table-column>
      <el-table-column property="history_action" label="干了什么"></el-table-column>
      <el-table-column property="history_talk" label="备注"></el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>

export default {
  props: {
    value: {
      type: [ String, Number ]
    }
  },
  data () {
    return {
      data: [],
      visible: false,
      loading: false
    }
  },
  watch: {
    value (val) {
      this.visible = !!val
    }
  },
  methods: {
    open () {
      this.loading = true
      this.$http.post('zhaopin/zhiwei/detail2', {
        jianli_id: this.value
      }).then(res => {
        if (res.data) {
          this.data = res.data.data
          this.data.forEach(item => {
            item = `${item.history_action}(${item.history_time})`
          })
        } else {
          // this.$message.error('对不起,你无权访问,如有需要请联系相关技术人员')
        }
        this.loading = false
      }).catch(err => {
        console.log(err)
        this.$message.error('对不起,你无权访问,如有需要请联系相关技术人员')
        this.loading = false
      })
    }
  }
}
</script>
